module.exports = __webpack_public_path__ + "media/customize/icon-bottom-right-7ba11dd3.svg";